// Automatically updated by @brillout/release-me
export const PROJECT_VERSION = '0.4.223';
